export default __webpack_public_path__ + "static/media/ferretti-infectiousness.10cd7faf.gif";